import { createRouter, createWebHistory } from 'vue-router'
import Tracker from '@shared/Tracker'
import useCorporateStore from '@shared/stores/useCorporateStore.js'
import { fromAppToStorage } from '@shared/helpers/isFromApp'
import env from '@shared/env.js'
import trackDetailedViewScreen from '@us/app/helpers/trackDetailedViewScreen.js'
import useAuthStore from '@shared/stores/useAuthStore.js'
import appModuleRouter from '@us/app/router/appModule'
import assessmentModuleRouter from '@shared/modules/assessment/router'
import useSharedStore from '@shared/stores/useSharedStore.js'

const initRouter = () => {
  const authStore = useAuthStore()

  const routerModules = [appModuleRouter, assessmentModuleRouter]

  const router = createRouter({
    routes: [
      // aggregate all routes from all modules
      ...routerModules.flatMap((module) => module.routes),
      // define a catch-all route
      {
        path: '/:pathMatch(.*)*',
        redirect: {
          name: appModuleRouter.ROUTE.PARTNER_SEARCH,
          params: {},
        },
      },
    ],
    linkActiveClass: 'open active',
    scrollBehavior: (to, from, savedPosition) =>
      savedPosition || { x: 0, y: 0 },
    history: createWebHistory(env.VITE_PUBLIC_PATH),
  })

  router.beforeEach(async (routeTo, routeFrom) => {
    if (routeTo.query.from_app) {
      fromAppToStorage()

      const { client_app_id, client_version } = routeTo.query

      authStore.hostClientAppId = Array.isArray(client_app_id)
        ? client_app_id[0]
        : client_app_id
      authStore.hostClientVersion = Array.isArray(client_version)
        ? client_version[0]
        : client_version
    }

    for (const module of routerModules) {
      // if the route is part of the module, run the hooks
      if (module.routes.find((route) => route.name === routeTo.name)) {
        return module.hooks(routeTo, routeFrom)
      }
    }
  })

  router.afterEach((routeTo) => {
    // Initialize Pinia stores for router hooks
    const corporateStore = useCorporateStore()
    const sharedStore = useSharedStore()

    Tracker.trackPageView(routeTo.fullPath, {
      ...sharedStore.utmData,
      landing_page_variant: sharedStore.initialQuery?.variant,
      corporate: corporateStore.corporate?.key,
      corporate_channel: corporateStore.corporate?.corporateChannel,
    })

    if (routeTo.meta && routeTo.meta.name) {
      // detailedTrackViewScreen
      const detailedViewScreenRouteNames = [
        'onb_eligibility_verification',
        'onb_account_creation',
        'corporate_landing_page',
        'simplified_corporate_landing_page',
      ]
      if (detailedViewScreenRouteNames.includes(routeTo.meta.name)) {
        trackDetailedViewScreen(
          Tracker,
          routeTo.meta.name,
          corporateStore.corporate,
          sharedStore.utmData,
        )
      } else {
        Tracker.trackViewScreen(routeTo.meta.name)
      }
    }
  })

  // ensure that the first page_view that is ever tracked on a session contains the initial Href
  // (this is needed for proper utm tracking)
  Tracker.trackPageView(window.location.href)

  return router
}

export default initRouter
